module.exports = __webpack_public_path__ + "img/add_photo.92987bed.svg";